// import React, { useState } from 'react';
import "./User.css";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import {
  getUserById,
  updateUser,
  userCategoriesList,
} from "../../../redux/user/action";
import { getAllServicesList } from "../../../redux/service/action";
import { updateCustomer } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import { useParams } from "react-router-dom";
import UserAddress from "./UserAddress";
import MapComponent from "./UserD";
import AddReferral from "./AddReferral";
import ClientList from "./ClientList";
import axiosInstance from "../../../redux/api";
import PdfPreviewImageUploader from "../Category/PdfPreviewImageUploader";
import OnboardingDetails from "./Zatca/OnboardingDetails";
import "../../Common/Styles/AdminEnhancements.css";
import { buildUserUpdatePayload } from "./userUpdateUtils";

const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address", name: "email_id" },
  { title: "Password", name: "password" },
  { title: "Status", name: "status" },
  { title: "Account Type", name: "is_testing_account" },
  { title: "Company Name", name: "company_name" },
  { title: "Company Registration Number", name: "company_registration_number" },
  { title: "Company VAT Number", name: "company_vat_number" },
  { title: "Company Certificate (Optional)", name: "company_cr" },
  { title: "Vat Certificate (Optional)", name: "vat_certificate" },
  { title: "Profile Image (Optional)", name: "profile_image" },
  { title: "Address", name: "address" },
];


const SavedAddressList = ({ data }) => {
  const [activeTab, setActiveTab] = useState("editUser");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const { id } = useParams();
  const [profileimage, setProfileimage] = useState(null);
  const [profilelogo, setProfileLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const [vatcertificate, setVatCartificate] = useState(null);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [myoptions, setOptions] = useState([]);

  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);

  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );

  const theServices = useSelector(
    (state) => state?.reusableSlice?.getSevices.services
  );

  const proOptions = categoryList?.categories?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));

  const [params, setParams] = useState({
    type: 2,
  });

  useEffect(() => {
    dispatch(userCategoriesList(params));
  }, [dispatch, params]);

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
      setUpdate(true);
    }
  }, [id]);

  useEffect(() => {
    theServices && setOptions(theServices);
  }, [theServices]);

  useEffect(() => {
    dispatch(getAllServicesList({ category_id: selectedUser.category_id }));
  }, [selectedUser]);

  const initialValues = {
    ...formData.reduce((acc, field) => {
      acc[field.name] = selectedUser?.[field.name] || "";
      return acc;
    }, {}),
    mobile_number: selectedUser?.mobile_number || "",
    country_code: selectedUser?.country_code || "",
    is_testing_account: selectedUser?.is_testing_account ? "1" : "0",
    category_id: selectedUser?.category_id || "",
    company_services:
      selectedUser && selectedUser.company_services !== ""
        ? selectedUser.company_services?.split(",").map(Number)
        : [],
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handelSubmit(value),
    validationSchema: updateCustomer(),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      const trimmedValue = inputValue.trim();
      if (!trimmedValue) return;

      const existingOption = myoptions.find(
        (opt) => opt.title.toLowerCase() === trimmedValue.toLowerCase()
      );

      let newSelectedOptions = [...formik.values.company_services];

      if (existingOption) {
        // Select existing option
        if (!newSelectedOptions.find((opt) => opt.id === existingOption.id)) {
          newSelectedOptions.push(existingOption);
        }
      } else {
        try {
          // Call API to add the new service
          const response = await axiosInstance.post(`/user/add_service`, {
            title: trimmedValue,
            category_id: formik.values.category_id,
          });

          if (response.data.status) {
            const newService = {
              id: response.data.response.id,
              title: trimmedValue,
            };

            // Update the options list with the new service
            setOptions([...myoptions, newService]);

            // Select the newly added service
            newSelectedOptions.push(newService.id);
          }
        } catch (error) {
          console.error("Error adding service:", error);
        }
      }

      formik.setFieldValue("company_services", newSelectedOptions);
      setInputValue("");
    }
  };

  const handelSubmit = async (values) => {
    setLoading(true);
    try {
      const updateData = buildUserUpdatePayload(values, selectedUser?.id);

      if (formik.values.category_id) {
        updateData.category_id = String(formik.values.category_id);
      } else {
        delete updateData.category_id;
      }

      if (
        Array.isArray(formik.values.company_services) &&
        formik.values.company_services.length
      ) {
        updateData.company_services = formik.values.company_services.join(",");
      } else {
        delete updateData.company_services;
      }

      dispatch(updateUser(updateData, setLoading, navigate));
      setUpdate(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();
  console.log(theServices, "theServices")
  return (
    <div className="p-3 category-wrapper">
      <h3 className="">Update Customer</h3>
      <div className="admin-highlight-box mt-2 mb-3">This screen is organized for admin operations. Optional documents can be skipped, and address can be entered manually if the map preview is unavailable.</div>
      <div
        className="pt-3 pb-3 d-flex align-items-center"
        style={{ columnGap: "10px", width: "50%" }}
      >
        <button
          onClick={() => handleTabClick("editUser")}
          className={`tab-button ${activeTab === "editUser" ? "active" : ""}`}
        >
          Profile & Company
        </button>
        <button
          onClick={() => handleTabClick("report")}
          className={`tab-button ${activeTab === "report" ? "active" : ""}`}
        >
          API & Connectivity
        </button>
        <button
          onClick={() => handleTabClick("clients")}
          className={`tab-button ${activeTab === "clients" ? "active" : ""}`}
        >
          Clients
        </button>
        <button
          onClick={() => handleTabClick("zatca")}
          className={`tab-button ${activeTab === "zatca" ? "active" : ""}`}
        >
          Zatca Integration
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "editUser" && (
          <Card>
            <CardBody className="">
              <form onSubmit={formik.handleSubmit}>
                <Row className=" ">
                  {formData.map((prop, key) => {
                    if (prop.title === "Mobile Number") {
                      return (
                        <Col className="  " key={key} xs={4}>
                          <div className="form-group">
                            <label htmlFor={prop.name}>{(prop.title)}</label>
                            <PhoneInput
                              country={"sa"}
                              // value={formik?.values.country_code ? `${formik.values.country_code}${formik.values.mobile_number}` : ''}
                              value={
                                formik.values.mobile_number
                                  ? `${formik.values.country_code}${formik.values.mobile_number}`
                                  : ""
                              }
                              onChange={(phone, data) =>
                                handleCountryCode(phone, data)
                              }
                              onBlur={() =>
                                formik.setFieldTouched(prop.name, true)
                              }
                            />
                          </div>

                          {(formik.touched.mobile_number ||
                            formik.errors.mobile_number) && (
                              <p style={{ color: "red" }}>
                                {formik.errors.mobile_number}
                              </p>
                            )}
                        </Col>
                      );
                    }
                    if (prop.name === "status") {
                      const options = [
                        { value: "1", label: ("Active") },
                        { value: "2", label: ("Inactive") },
                        { value: "3", label: ("Block") },
                      ];

                      return (
                        <Col className="  form-group" key={key} xs={4}>
                          <label>{(prop.title)}</label>
                          <div>
                            <ReactSelect
                              // className='form-control'
                              value={options.find(
                                (option) =>
                                  option.value == formik.values?.[prop.name]
                              )}
                              placeholder={(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              options={options}
                              onChange={(selectedOption) =>
                                formik.handleChange(prop.name)(
                                  selectedOption.value
                                )
                              }
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched[prop.name] &&
                              formik.errors[prop.name] && (
                                <div className="error">
                                  {(formik.errors[prop.name])}
                                </div>
                              )}
                          </div>
                        </Col>
                      );
                    }

                    if (prop.name === "is_testing_account") {
                      const options = [
                        { value: "0", label: "Customer" },
                        { value: "1", label: "Testing Account" },
                      ];

                      return (
                        <Col className="form-group" key={key} xs={4}>
                          <label>{prop.title}</label>
                          <ReactSelect
                            value={options.find(
                              (option) =>
                                option.value ===
                                String(formik.values?.is_testing_account ?? "0")
                            )}
                            placeholder={prop.title}
                            id={prop.name}
                            name={prop.name}
                            options={options}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "is_testing_account",
                                selectedOption?.value || "0"
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                        </Col>
                      );
                    }

                    if (prop.name == "company_services") {
                      return (
                        <div className="form-group col-md-6" key={key}>
                          <label>{prop.title}</label>
                          <CreatableSelect
                            isMulti
                            id="company_services"
                            name="company_services"
                            options={myoptions && myoptions}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            value={myoptions.filter((option) =>
                              formik.values.company_services?.includes(
                                option.id
                              )
                            )}
                            // value={formik.values.company_services}
                            onChange={(selected) =>
                              formik.setFieldValue(
                                "company_services",
                                selected.map((item) => item.id) || []
                              )
                            }
                            inputValue={inputValue}
                            onInputChange={(val) => setInputValue(val)}
                            onKeyDown={handleKeyDown}
                            placeholder="Type and press space/enter to add"
                            menuIsOpen={false}
                            components={{
                              DropdownIndicator: () => null,
                              IndicatorSeparator: () => null
                            }}
                          />
                          <i>Press Enter to add multiple services</i>
                          {formik.touched.company_services &&
                            formik.errors.company_services && (
                              <p className="error-message">
                                {formik.errors.company_services}
                              </p>
                            )}
                        </div>
                      );
                    }

                    if (prop.name === "company_registration_number") {
                      return (
                        <Col className="  " key={key} xs={4}>
                          <div className="form-group">
                            <label>{prop.title}</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                              type="number"
                            />
                          </div>
                        </Col>
                      );
                    }
                    if (prop.name === "company_vat_number") {
                      return (
                        <Col className="  " key={key} xs={4}>
                          <div className="form-group">
                            <label>{prop.title}</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                              type="number"
                            />
                          </div>
                        </Col>
                      );
                    }

                    if (prop.name === "password") {
                      return (
                        <Col className="  " key={key} xs={4}>
                          <div className="form-group">
                            <label>Password</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                            />
                            {formik.touched.password &&
                              formik.errors.password && (
                                <p style={{ color: "red" }}>
                                  {formik.errors.password}
                                </p>
                              )}
                          </div>
                        </Col>
                      );
                    }

                  
                    if (prop.name === "category_id") {
                      return (
                        <Col className="px-2 py-2" key={key} xs={4}>
                          <label>{prop.title}</label>
                          <ReactSelect
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            options={categoryList?.categories}
                            placeholder="Select Categories"
                            onChange={(selectedOption) => {
                              if (selectedOption?.id) {
                                dispatch(
                                  getAllServicesList({
                                    category_id: selectedOption.id,
                                  })
                                );
                                setOptions([]);
                                formik.setFieldValue("company_services", []);
                                formik.setFieldValue(
                                  "category_id",
                                  selectedOption.id
                                ); // Update Formik value
                              }
                            }}
                            value={
                              categoryList?.categories?.find(
                                (cat) =>
                                  Number(cat.id) ===
                                  Number(formik.values.category_id)
                              ) || null
                            }
                          />
                        </Col>
                      );
                    }

                    if (prop.name === "address") {
                      return (
                        <Col  className="category-wrapper bg-white mt-2" xs={12} key={key}>
                          <div className="admin-section-title"><h5>Address Details</h5><span className="admin-optional-badge">Map optional</span></div>
                          <p className="admin-section-note">Manual address entry works even when Google Maps is blocked or unavailable.</p>
                          {formik.touched.address && formik.errors.address && (
                            <p style={{ color: "red" }}>
                              {formik.errors.address}
                            </p>
                          )}
                          <MapComponent
                            prop={prop}
                            setFieldValue={formik.setFieldValue}
                            value={formik.values[prop.name]}
                            formik={formik}
                            x={selectedUser.latitude}
                            y={selectedUser.longitude}
                          />
                        </Col>
                      );
                    }
                    if (prop.name === "company_cr") {
                      return (
                        <>
                          <Col xs={12}>
                            <div className="admin-section-card admin-form-section-spacer">
                              <div className="admin-section-title">
                                <h5>Optional Company Documents</h5>
                                <span className="admin-optional-badge">Optional</span>
                              </div>
                              <p className="admin-section-note">These files are not required for saving customer updates. Add or replace them only when needed.</p>
                            </div>
                          </Col>
                          <UploadImage
                            files={profileimage}
                            setFiles={setProfileimage}
                            update={update}
                            prop={prop}
                            formik={formik}
                          />

                        </>
                      );
                    }

                    if (prop.name == "vat_certificate") {
                      return (
                        <>
                          <UploadImage
                            files={vatcertificate}
                            setFiles={setVatCartificate}
                            update={update}
                            prop={prop}
                            formik={formik}
                          />
                          <div></div>
                        </>
                      );
                    }
                    if (prop.name === "profile_image") {
                      return (
                        <>
                          <UploadImage
                            files={profilelogo}
                            setFiles={setProfileLogo}
                            update={update}
                            prop={prop}
                            formik={formik}
                            type={'onlyimage'}
                          />
                          <div></div>
                        </>
                      );
                    }
                    if (prop.name === "email_id") {
                      return (
                        <Col className="  " key={key} xs={4}>
                          <div className="form-group">
                            <label>{prop?.title}</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                            />
                          </div>
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {(formik.errors[prop.name])}
                              </div>
                            )}
                        </Col>
                      );
                    }
                    return (
                      <Col className="  " key={key} xs={4}>
                        <div className="form-group">
                          <label>{prop?.title}</label>
                          <CustomInput
                            value={formik.values?.[prop.name]}
                            placeholder={(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            touched={formik.touched}
                            errors={formik.errors}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <p style={{ color: "red" }}>
                                {(formik.errors[prop.name])}
                              </p>
                            )}
                        </div>
                      </Col>
                    );
                  })}
                  <Col
                    md={12}
                    className="text-center my-3 d-flex align-items-center justify-content-between"
                  >
                    <button
                      className="submit-btn"
                      disabled={loading}
                      onClick={() => navigate("/user")}
                      type="submit"
                    >
                      Back
                    </button>
                    <button
                      style={{ width: "max-content" }}
                      className="submit-btn"
                      disabled={loading}
                      type="submit"
                    >
                      {!loading ? "Update" : <Spinner />}
                    </button>
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
        )}

        {activeTab === "report" && (
          <div className="card">
            <UserAddress
              id={id}
              selectedUser={selectedUser}
              userId={selectedUser?.id}
            ></UserAddress>
          </div>
        )}

        {activeTab === "clients" && (
          <div className="card">
            <ClientList
              id={id}
              selectedUser={selectedUser}
              userId={selectedUser?.id}
            ></ClientList>
          </div>
        )}
        {activeTab === "zatca" && <OnboardingDetails />}


      </div>
    </div>
  );
};

export default SavedAddressList;
